import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SweetAlertService from "../../../services/SweetAlertService";
import { countryNameMaxLength, errorMessages, getMaxLengthErrorMessage, getRequiredErrorMessage, namePattern } from "../Shared/Constants/AdminModuleConstants";
import CountryService from "../Shared/Services/CountryService";

export const AddCountry = () => {
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const onSubmit = (data: any) => {
        // Perform form submission
        data.name = data.name.trim();
        CountryService.add(data).then((res) => {
            if (res) {
                navigate("/country");
            } else {

            }
            // Reset form
            reset();
        }).catch(error => {
            if (error) {
                SweetAlertService.error("Error", error.response.data.errors.Name[0]);
            }
        })
    };

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h4>Create Country</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group row">
                            <label className="col-lg-3 control-label">Name</label>
                            <div className="col-lg-9">
                                <input className="form-control" type="text" {...register("name", {
                                    required: getRequiredErrorMessage("Name"),
                                    pattern: {
                                        value: namePattern,
                                        message: errorMessages.pattern
                                    },
                                    maxLength: {
                                        value: countryNameMaxLength,
                                        message: getMaxLengthErrorMessage(countryNameMaxLength)
                                    }
                                })} />
                                {errors.name && <span className="help-block m-b-none text-danger field-validation-valid">{errors.name.message?.toString()}</span>}
                            </div>
                        </div>
                        <br />
                        <div className="form-group row">
                            <div className=" col-sm-offset-3 px-2">
                                <a className="btn btn-secondary" onClick={() => navigate('/country')}>Cancel</a>
                                <button className="btn btn-primary ms-1" type="submit">Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}